import BasePanel from './BasePanel';

class MouvementPanel extends BasePanel {
	// Propriété qui sert à savoir si le bloc affecte le mouvement ou les lignes
	isOnlyMouvement = true;
}

export default MouvementPanel;
